// extracted by mini-css-extract-plugin
export default {"form":"Login_form__UohUC","logo_container":"Login_logo_container__ip-k-"};